/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'users': {
    width: 20,
    height: 18,
    viewBox: '0 0 20 18',
    data: '<path pid="0" d="M11 4.5C11 6.732 9.801 9 7.5 9S4 6.732 4 4.5 4.028 0 7.5 0 11 2.268 11 4.5zM0 18c0-5.097 2.083-7 6.667-7h1.666C12.083 11 15 12.286 15 18H0zM11.756 8.727a5.942 5.942 0 01-.114.159c.267.074.553.114.858.114C14.8 9 16 6.732 16 4.5S15.972 0 12.5 0c-.16 0-.314.005-.46.014.106.153.2.312.286.475.678 1.302.676 2.88.674 3.87V4.5c0 1.44-.38 2.983-1.244 4.227zM20 18h-3c0-3.028-.742-5.376-2.383-6.942C17.728 11.363 20 12.957 20 18z" _fill="#0071B3"/>'
  }
})
